import { HostPlatform } from 'src/config/hostPlatform';

function transformIssue(issue) {
  return {
    id: issue.id,
    name: issue.fields.summary,
    type: issue.fields.issuetype.id,
    key: issue.key,
  };
}

/**
 * Get action items by ID
 * @param {Array<number>} itemIds  - List of Items ID
 * @returns {Promise<Array>} - The items
 */
async function getItemsByIds(itemIds) {
  const issues = await Promise.all(itemIds.map((id) => getIssueById(id)));
  return issues.map((issue) => transformIssue(issue));
}

/**
 * Create new action item
 * @param {string} projectId - The project ID
 * @param {string} name - The name of the Item
 * @param {Object} issueType - The issue type
 */
async function createItem(projectId, name, issueType) {
  return new Promise((resolve, reject) => {
    AP.jira.openCreateIssueDialog(
      (issues) => {
        if (!issues || issues?.length === 0) {
          reject();
        } else {
          const [firstIssue] = issues;
          resolve({ id: firstIssue.id });
        }
      },
      {
        pid: projectId,
        issueType: issueType.id,
        fields: {
          summary: name,
        },
      }
    );
  });
}
async function openItemDialog(issueId) {
  const issue = await getIssueById(issueId);
  return new Promise((resolve) => {
    AP.jira.openIssueDialog(issue.key, () => {
      resolve();
    });
  });
}
async function getIssueById(issueIdOrKey) {
  const response = await AP.request(`/rest/api/3/issue/${issueIdOrKey}`);
  return JSON.parse(response.body);
}
const getItemTypes = async () => {
  const projectId = HostPlatform.getContext().boardId;

  const issueTypesRequest = await AP.request(
    `/rest/api/3/issuetype/project?projectId=${projectId}`
  );

  if (issueTypesRequest.xhr.status === 200) {
    const issueTypes = JSON.parse(issueTypesRequest.body);
    return issueTypes.filter((issueType) => !issueType.subtask);
  }

  return [];
};

export { getItemsByIds, createItem, openItemDialog, getItemTypes };
